"use strict";

class Overview {

	constructor() {

		this.bgImage = "images/cph_highline_main_bg.jpg";
		this.backgroundImageWidth = 3840;
		this.backgroundImageHeight = 2740;
		this.targetContainer = "ui-outer";
		this.rootContainer = "overview-outer";
		this.bgImageContainer = "overview-bg";
		this.visible = false;
		this.isAnimating = false;
		this.allPOICategoriesHiddenByDefault = true;

		this.initOverview();
	}

	initOverview() {

		let bgImage = new Image();
		bgImage.src = this.bgImage;

		bgImage.onload = () => {
			this.addPageElements(bgImage.src);
		};
	}

	handleBrowserSpecificFixes() {

		if(AppTools.browserIsEdge()) {

			$(".overview-hotspot-container").css("transition-property", "none");
			$(".overview-hotspot-image-container").css("transition-property", "none");
		}
	}

	addPageElements(bgImageSrc) {

		// set up outer elements
		let target = $("#"+this.targetContainer);

		target.append($("<div>")
			.addClass("overview-outer")
			.attr("id", this.rootContainer)

			.append($("<div>")
				.addClass("overview-bg")
				.attr("id", this.bgImageContainer)
				.css("background-image", "url('" + bgImageSrc + "')")
			)
		);

		// add additional overlays
		this.addLogo();
		this.parseOverviewData();
		this.populateHotspotsFromSceneData();
		this.handleBrowserSpecificFixes();

		this.show(false);
	}

	populateHotspotsFromSceneData() {

		let scenes = sceneCollection.getAllScenes();

		for(let i=0; i<scenes.length; i++) {
			this.addHotspot(scenes[i].overviewPosX, scenes[i].overviewPosY, scenes[i].overviewImage, scenes[i].name);
		}
	}

	placeOverview() {

		let outer = $("#"+this.rootContainer);
		let container = $("#"+this.bgImageContainer);

		let containerWidth = parseInt(outer.width());
		let containerHeight = parseInt(outer.height());

		let minRatio = Math.min(containerWidth / this.backgroundImageWidth, containerHeight / this.backgroundImageHeight);
		let newImgWidth = minRatio * this.backgroundImageWidth;
		let newImgHeight = minRatio * this.backgroundImageHeight;

		let newImgX = (containerWidth - newImgWidth) / 2;
		let newImgY = (containerHeight - newImgHeight) / 2;

		container.css("left", newImgX);
		container.css("top", newImgY);

		container.css("width", newImgWidth);
		container.css("height", newImgHeight);
	}

	toggleVisibility() {

		this.visible = !this.visible;
		this.show(this.visible);
	}

	show(visible) {

		let container = $("#"+this.rootContainer);

		if(visible) {
			container.css("opacity", "0.0");
			container.css("display", "inline");
			container.animate({opacity: 1.0, easing: "swing"}, 1000);
		} else {
			container.css("opacity", "1.0");
			container.animate({opacity: 0.0, easing: "swing"}, 1000, function() {
				container.css("display", "none");
			});
		}
		
		this.placeOverview();
		this.visible = visible;
	}

	parseOverviewData() {

		// handle basic text
		let headline = overviewData.headline;
		let subtext = overviewData.subtext;
		this.addDescription(headline, subtext);

		// handle POI data
		let poiLayers = [];

		for(let i=0; i<overviewData.poiCollections.length; i++) {

			let layerName = overviewData.poiCollections[i].layerName;
			poiLayers.push(layerName);

			let points = overviewData.poiCollections[i].points;
			for(let j=0; j<points.length; j++) {

				this.addPOI(points[j].x, points[j].y, points[j].headline, points[j].subtext, points[j].tintColor, layerName);
			}
		}

		this.addPOIMenu(poiLayers);
	}

	addLogo() {

		let container = $("#"+this.bgImageContainer);

		container.append($("<div>")
			.addClass("overview-logo")
			.addClass("scale")
		);
	}

	addDescription(headline, subtext) {

		let container = $("#"+this.bgImageContainer);

		container.append($("<div class='overview-description-container'>")

			.append($("<div>")
				.addClass("overview-headline")
				.text(headline)
			)

			.append($("<div>")
				.addClass("overview-subtext")
				.text(subtext)
			)
		);
	}

	addHotspot(normPosX, normPosY, thumbnailPath, sceneName) {

		var that = this;

		let container = $("#"+this.bgImageContainer);

		let finalRelPosX = normPosX * 100;
		let finalRelPosY = normPosY * 100;

		let hotspotContainer = container.append($("<div class='overview-hotspot-container visibility'>")
			.css("left", finalRelPosX+"%")
			.css("top", finalRelPosY+"%")

			.click(function() {
				that.onHotspotSelected(sceneName);
			})

			.append($("<div>")
				.addClass("overview-hotspot-outer")
			)

			.append($("<div>")
				.addClass("overview-hotspot-inner")
				.text("+")
			)

			.append($("<div><img src='" + thumbnailPath + "' class='overview-hotspot-image'></div>")
				.addClass("overview-hotspot-image-container")
			)
		);
	}

	addPOI(normPosX, normPosY, header, subtext, tintColor, layerName) {

		let container = $("#"+this.bgImageContainer);

		let finalRelPosX = normPosX * 100;
		let finalRelPosY = normPosY * 100;

		let chosenLayer = (tintColor)

		container.append($("<div class='overview-poi-container'>")
			.css("left", finalRelPosX+"%")
			.css("top", finalRelPosY+"%")
			.attr("data-options", "{\"tag\": \"" + layerName + "\" }")

			.append($("<div>")
				.addClass("overview-poi-label-header")
				.text(header)
			)

			.append($("<div>")
				.addClass("overview-poi-label-sub")
				.text(subtext)
			)

			.append($("<div>")
				.addClass("overview-poi-symbol")
				.addClass(tintColor)
			)
		);
	}

	addPOIMenu(layers) {

		var that = this;

		let target = $("#"+this.bgImageContainer);
		let containerClass = "overview-poi-menu-container";

		target.append($("<div>").addClass(containerClass).addClass("visibility"));

		let container = $("." + containerClass);

		for(let i=0; i<layers.length; i++) {

			container.append($("<div>")

				.addClass("poi-menu-cell")
				.addClass(layers[i])
				.click(function() {
					that.onTogglePOI($(this), layers[i]);
				})

				.append($("<div>")
					.addClass("poi-menu-cell-inactive")
					.addClass(layers[i])
				)
			);
		}

		if(this.allPOICategoriesHiddenByDefault) {
			$(".poi-menu-cell-inactive").show();
			$(".overview-poi-container").css("opacity", "0.0");
		}
	}

	onTogglePOI(element, layerName) {

		// skip if transition is in progress
		if(this.isAnimating) {
			return;
		} else {
			this.isAnimating = true;
		}

		let disabledOverlayTarget = element.children().first();
		let visible = !disabledOverlayTarget.is(":visible");
		let sourceClass = "overview-poi-container";
		let fadeDuration = 500;

		let finalState = !visible;
		var that = this;

		// handle poi visibility
		$("#"+this.bgImageContainer).find("."+sourceClass).each(function() {
			let tag = $(this).data("options").tag;

			if(tag === layerName) {

				if(finalState) {
					$(this).css("opacity", "0.0");
					$(this).show();
					$(this).animate({opacity: 1.0}, fadeDuration,
					function() {
						that.isAnimating = false;
					})

				} else {
					$(this).css("opacity", "1.0");
					$(this).animate({opacity: 0.0}, fadeDuration,
					function() {
						$(this).hide();
						that.isAnimating = false;
					})
				}
			}
		});

		// handle visibility of the selection layer
		if(finalState) {
			disabledOverlayTarget.hide();
		} else {
			disabledOverlayTarget.show();
		}
	}

	onHotspotSelected(sceneName) {

		this.show(false);
		viewer.loadScene(null, sceneName);
		viewerUI.selectActiveSceneByName(sceneName);
	}

	activateMousePosReporting() {

		document.addEventListener('mouseup', e => { this.onMouseUp(e); }, false);
	}

	onMouseUp(event) {

		let element = $("#"+this.bgImageContainer);

		let x = event.pageX - element.offset().left;
		let y = event.pageY - element.offset().top;

		let relativePosX = x / element.innerWidth();
		let relativePosY = y / element.innerHeight();

		console.log("Absolute (x,y): " + x + ", " + y);
		console.log("Relative (x,y): " + relativePosX + ", " + relativePosY);
	}

}